import { Component, Input } from '@angular/core';
// import { BizEntityStateStoreService } from '../../../state/state-store-service/biz-entity/biz-entity-state-store/biz-entity-state-store.service';
import { IBizEntity } from '@optima-stride-ai/core';
// import { IDeleteAPIResponse } from '../../../state/state-interfaces/api-response.model';


@Component({
    selector: 'app-confirmation-dialogue',
    imports: [],
    templateUrl: './confirmation-dialogue.component.html',
    styleUrl: './confirmation-dialogue.component.sass'
})
export class ConfirmationDialogueComponent{
  @Input() message: string = '';
  @Input() title: string = '';
  @Input() apiMethodCall: Function = () => {};
  @Input() bizEntity: IBizEntity | string | undefined ;

  get data(): string{
    return this.message;
  }
}
